// Convert the date to Finland time (Europe/Helsinki) and set to 00:00
export const startOfDay = (date) => {
  const finlandTime = new Date(
    new Date(date).toLocaleString('en-US', { timeZone: 'Europe/Helsinki' })
  );
  finlandTime.setHours(0, 0, 0, 0); // Set to 00:00
  return finlandTime.getTime();
};

// Convert the date to Finland time (Europe/Helsinki) and set to 23:59
export const endOfDay = (date) => {
  const finlandTime = new Date(
    new Date(date).toLocaleString('en-US', { timeZone: 'Europe/Helsinki' })
  );
  finlandTime.setHours(23, 59, 59, 999); // Set to 23:59:59.999
  return finlandTime.getTime();
};

export const getFreeSlots = (programs, dayStart, dayEnd, previousDayPrograms = []) => {
  const freeSlots = [];

  // Include the last program from the previous day if it overlaps
  const lastPreviousProgram =
    previousDayPrograms.length > 0
      ? previousDayPrograms[previousDayPrograms.length - 1]
      : null;

  let adjustedDayStart = dayStart;
  if (lastPreviousProgram && lastPreviousProgram.end > dayStart) {
    adjustedDayStart = lastPreviousProgram.end; // Start after the last program from the previous day
  }

  // Sort programs by start time
  const sortedPrograms = programs.sort((a, b) => a.start - b.start);

  // Check for free time before the first program
  if (sortedPrograms.length > 0 && sortedPrograms[0].start > adjustedDayStart) {
    freeSlots.push({
      start: new Date(adjustedDayStart),
      end: new Date(sortedPrograms[0].start),
    });
  }

  // Find gaps between programs
  for (let i = 0; i < sortedPrograms.length - 1; i++) {
    const currentProgram = sortedPrograms[i];
    const nextProgram = sortedPrograms[i + 1];

    if (currentProgram.end < nextProgram.start) {
      freeSlots.push({
        start: new Date(currentProgram.end),
        end: new Date(nextProgram.start),
      });
    }
  }

  // Check for free time after the last program
  if (
    sortedPrograms.length > 0 &&
    sortedPrograms[sortedPrograms.length - 1].end < dayEnd
  ) {
    freeSlots.push({
      start: new Date(sortedPrograms[sortedPrograms.length - 1].end),
      end: new Date(dayEnd),
    });
  }

  // If no programs exist, the entire day is free
  if (sortedPrograms.length === 0) {
    freeSlots.push({
      start: new Date(adjustedDayStart),
      end: new Date(dayEnd),
    });
  }

  return freeSlots;
};

export const groupBy = (xs, key) =>
  xs.reduce((rv, x) => {
    var v = key instanceof Function ? key(x) : x[key];
    (rv[v] = rv[v] || []).push(x);
    return rv;
  }, {});
